import React from 'react'
import logo from "../assets/images/logo.png"
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
export default function Navbar() {
    const {t,i18n} = useTranslation()
    if(i18n.language === 'ar'){
        document.body.style.direction = "rtl"
    }else if (i18n.language === 'en'){
        document.body.style.direction = "ltr"
    }

    const location = useLocation()
  return (
    <div>
      {
        location.pathname === '/home'?
        <nav className="navbar navbar-expand-lg  nav-bg fixed-top">
        <div className="container">
        <img className='logo' src={logo} alt="" />
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className={i18n.language == 'ar'?"navbar-nav me-auto mb-2 mb-lg-0":"navbar-nav ms-auto mb-2 mb-lg-0"}>
              <li className="nav-item">
                <a className="nav-link active" aria-current="page" href="#home" >{t('home')}</a>
              </li>
              <li className="nav-item">
                <a className="nav-link active" aria-current="page" href="#about" >{t('about')}</a>
              </li>
              <li className="nav-item">
                <a className="nav-link active" aria-current="page" href="#projects" >{t('projects')}</a>
              </li>
              <li className="nav-item ">
                <a className='btn nav-btn' href='#contact'>{t('contact')}</a>
              </li>
              <select className={i18n.language == 'ar'?"form-select lang-menu-ltr":"form-select lang-menu"   } onChange={(e)=>  {i18n.changeLanguage(e.target.value)}} name="" id="">
                  <option value="en">English</option>
                  <option value="ar">Arabic</option>
              </select>
             
            </ul>
            
          </div>
        </div>
      </nav>
        :
         <nav className="navbar navbar-expand-lg  nav-bg fixed-top">
  <div className="container">
  <img className='logo' src={logo} alt="" />
    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"></span>
    </button>
    <div className="collapse navbar-collapse" id="navbarSupportedContent">
      <ul className={i18n.language == 'ar'?"navbar-nav me-auto mb-2 mb-lg-0":"navbar-nav ms-auto mb-2 mb-lg-0"}>
        <li className="nav-item">
          <Link className="nav-link active" aria-current="page" href="#home" to={"/home"}>{t('home')}</Link>
        </li>
        <li className="nav-item">
          <Link className="nav-link active" aria-current="page" href="#about" to={"/home"}>{t('about')}</Link>
        </li>
        <li className="nav-item">
          <Link className="nav-link active" aria-current="page" href="#projects" to={"/home"}>{t('projects')}</Link>
        </li>
        <li className="nav-item ">
          <a className='btn nav-btn' href='#contact'>{t('contact')}</a>
        </li>
        <select className={i18n.language == 'ar'?"form-select lang-menu-ltr":"form-select lang-menu"   } onChange={(e)=>  {window.localStorage.language = e.target.value;i18n.changeLanguage(e.target.value)}}  value={i18n.language} name="" id="">
        <option value="en" >English</option>
            <option value="ar" >Arabic</option>
            
        </select>
       
      </ul>
      
    </div>
  </div>
</nav>
      }
       
    </div>
  )
}
